import React from 'react';
import { lightFormat } from 'date-fns';
import utilSvc from '../../utilSvc';

const FormattedDateRenderer = <TItem extends { [key: string]: any }>({
    item,
    colKey,
}: {
    item: TItem;
    colKey: string;
}): JSX.Element => {
    return <>{utilSvc.dt.isValid(item[colKey]) ? lightFormat(item[colKey], utilSvc.dt.fmtMdyyyy) : null}</>;
};

export default FormattedDateRenderer;
